import {
  resetUploadStatus,
  uploadKTP,
} from "features/common/layouts/cartSlice";
import { fileToBase64 } from "helpers/helper";
import { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
// import styles from "../../assets/scss/ModalUploadImage.module.scss"; // File sudah dihapus
import { notifyError } from "components/ToastMessage";

const videoConstraints = {
  width: 500,
  height: 400,
  facingMode: "user",
};

const ModalUploadImage = (props) => {
  const dispatch = useDispatch();
  const { uploadStatus, code, message } = useSelector(
    (state) => state.cart.ktpCard
  );
  const inputFileRef = useRef(null);
  const webcamRef = useRef(null);
  const uploadBtnRef = useRef(null);

  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [rawFiles, setRawFiles] = useState(null);
  const [useCamera, setUseCamera] = useState({
    title: "Buka Kamera",
    status: false,
  });
  const [disableUploadBtn, setDisableUploadBtn] = useState(true);

  useEffect(() => {
    setDisableUploadBtn(rawFiles ? false : true);
  }, [rawFiles]);

  useEffect(() => {
    setDisableUploadBtn(false);
    const timer = setTimeout(() => {
      if (uploadStatus === "user_agree") {
        props.handler(false);
      } else {
        dispatch(resetUploadStatus("waiting"));
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [uploadStatus, props, dispatch]);

  const captureCam = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setThumbnailImg(imageSrc);
    setRawFiles(imageSrc);
    setUseCamera({
      title: "Buka Kamera",
      status: false,
    });
  }, [webcamRef]);

  const selectImageHandle = () => {
    inputFileRef.current.click();
  };

  const useCameraHandle = () => {
    if (!useCamera.status) {
      setThumbnailImg(null);
      setUseCamera({ title: "Tutup Kamera", status: true });
    } else {
      setUseCamera({ title: "Buka Kamera", status: false });
    }
  };

  const getImage = async (e) => {
    const { length: filesLength } = e.target.files;

    if (filesLength > 0) {
      const fileData = e.target.files[0];
      const thumbnail = await fileToBase64(fileData);
      setRawFiles(fileData);
      setThumbnailImg(thumbnail);
    }
  };

  const clearImageHandler = () => {
    setRawFiles(null);
    setThumbnailImg(null);
    inputFileRef.current.value = "";
  };

  const uploadImageHandler = async (e) => {
    if (typeof rawFiles === "string") {
      // rawFiles is in base64 format, directly send it
      setDisableUploadBtn(true);
      dispatch(uploadKTP(rawFiles));
    } else {
      if (rawFiles.size > 2 * 1024 * 1024) {
        notifyError(
          "Harap periksa ukuran file Anda. Ukuran maksimal yang diperbolehkan adalah 2MB."
        );
        return;
      }

      if (
        rawFiles.type !== "image/jpg" &&
        rawFiles.type !== "image/png" &&
        rawFiles.type !== "image/jpeg"
      ) {
        notifyError(
          "Maaf, hanya file dengan ekstensi PNG, JPG, dan JPEG yang diperbolehkan."
        );
        return;
      }

      setDisableUploadBtn(true);
      dispatch(uploadKTP(rawFiles));
    }
  };

  const uploadLaterHandler = () => {
    dispatch(resetUploadStatus("user_agree"));
  };
  return (
    <Modal show={props.show} onHide={props.onHide} dialogClassName="modal-lg" centered>
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="fw-bold">
          Upload Foto Selfie dengan KTP/SIM/KITAS/Passport
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <div className="mb-4">
          <div
            className={`d-flex align-items-center justify-content-center flex-column bg-light border border-2 border-dashed rounded-3 cursor-pointer overflow-hidden position-relative ${
              thumbnailImg ? "border-success" : "border-secondary"
            }`}
            onClick={selectImageHandle}
            style={{
              minHeight: "300px",
              width: "100%",
              padding: "2rem",
              transition: "all 0.3s ease"
            }}
          >
            <input
              ref={inputFileRef}
              name="image-ktp"
              type="file"
              className="d-none"
              onChange={getImage}
              accept="image/*"
            />
            {!thumbnailImg && !useCamera.status && (
              <div className="text-center">
                <div className="mb-3">
                  <i className="fas fa-cloud-upload-alt" style={{ fontSize: "48px", color: "#6c757d" }}></i>
                </div>
                <h6 className="fw-bold mb-2">Klik untuk Upload Foto</h6>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                  <i className="fas fa-info-circle me-1"></i>
                  Maks. 2MB | Format: PNG, JPG, JPEG
                </p>
              </div>
            )}
            {thumbnailImg && (
              <img
                src={thumbnailImg}
                alt="Preview KTP"
                className="img-fluid rounded"
                style={{ maxHeight: "400px", maxWidth: "100%", objectFit: "contain" }}
              />
            )}
            {useCamera.status && (
              <div className="w-100 d-flex justify-content-center">
                <Webcam
                  audio={false}
                  height={400}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={500}
                  videoConstraints={videoConstraints}
                  className="rounded"
                />
              </div>
            )}
          </div>
        </div>
        
        <div className="d-flex justify-content-between align-items-center gap-3">
          <button
            className="btn btn-outline-secondary d-flex align-items-center gap-2"
            type="button"
            onClick={useCameraHandle}
          >
            <i className={`fas ${useCamera.status ? "fa-video-slash" : "fa-video"}`}></i>
            {useCamera.title}
          </button>
          {rawFiles && !useCamera.status && (
            <button
              className="btn btn-outline-danger d-flex align-items-center gap-2"
              onClick={clearImageHandler}
            >
              <i className="fas fa-trash-alt"></i>
              Hapus Foto
            </button>
          )}
          {useCamera.status && (
            <button 
              className="btn btn-success d-flex align-items-center gap-2" 
              onClick={captureCam}
            >
              <i className="fas fa-camera"></i>
              Capture
            </button>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="flex-column border-top pt-3">
        <div className="w-100 mb-3">
          <small className="text-muted d-block text-center" style={{ fontSize: "12px", lineHeight: "1.5" }}>
            <i className="fas fa-info-circle me-1"></i>
            Lengkapi syarat pendaftaran paling lambat 3x24 jam setelah memesan layanan.
            <br />
            Baca ketentuan lengkap di{" "}
            <a
              href={`${process.env.REACT_APP_QWORDS_API}master-service-agreement/term-of-service/?_gl=1*1gc74x2*_gcl_aw*R0NMLjE2NzQwOTQyNTQuQ2p3S0NBaUF6cDZlQmhCeUVpd0FfZ0dxNUNid083RGt4Z2M5V00waXd2M2p5NE94bkpZTjhxOVpRMVJpZHlZYU1WRHUtRFUxSVVHdTBCb0NQdmtRQXZEX0J3RQ..&_ga=2.209351954.1691100910.1676855061-648682774.1669949929&_gac=1.120643962.1674094254.CjwKCAiAzp6eBhByEiwA_gGq5CbwO7Dkxgc9WM0iwv3jy4OxnJYN8q9ZQ1RidyYaMVDu-DU1IUGu0BoCPvkQAvD_BwE`}
              target="_blank"
              rel="noreferrer"
              className="text-qw-primary text-decoration-underline"
            >
              Term of Service Point 13
            </a>
          </small>
        </div>
        
        <div className="w-100 d-flex flex-column align-items-center gap-3">
          {uploadStatus === "fail_upload" && code === 400 && (
            <div className="alert alert-danger mb-0 w-100 text-center">
              <i className="fas fa-exclamation-circle me-2"></i>
              {message} Gagal Upload!
            </div>
          )}
          {uploadStatus === "uploading" && (
            <div className="d-flex align-items-center gap-2">
              <Spinner animation="border" size="sm" />
              <span className="text-muted">Mengupload...</span>
            </div>
          )}
          {uploadStatus === "user_agree" && code === 200 && (
            <div className="alert alert-success mb-0 w-100 text-center">
              <i className="fas fa-check-circle me-2"></i>
              File Berhasil diupload!
            </div>
          )}

          {(!uploadStatus || uploadStatus === "waiting") && (
            <button
              className="btn btn-cta fw-bold w-100"
              type="button"
              onClick={uploadImageHandler}
              ref={uploadBtnRef}
              disabled={disableUploadBtn}
            >
              <i className="fas fa-upload me-2"></i>
              Upload Foto
            </button>
          )}
          <button
            className="btn btn-link text-muted text-decoration-none p-0"
            onClick={uploadLaterHandler}
            style={{ fontSize: "14px" }}
          >
            Upload nanti
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUploadImage;
